module.exports = __webpack_public_path__ + "static/matt_profile-cf0f92fc177e0dfe1d99d6dc7fdaa5ef.jpg";